export enum PredictiveIntentAutomationEnum {
    EXISTING_AUTOMATIONS = 'EXISTING AUTOMATIONS',
    NEW_AUTOMATION = 'NEW AUTOMATION',
}